/* istanbul ignore file */
import { NavLink } from 'react-router-dom';

import ZuiLink from '@zenbusiness/zui/Link';
import List from '@zenbusiness/zui/List';
import ListItemButton from '@zenbusiness/zui/ListItemButton';
import { superstyled } from '@zenbusiness/zui/styles';
import ZuiText from '@zenbusiness/zui/Text';

export const menuItemMixin = (theme) => ({
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
  gap: '0.5rem',
  padding: 0,
  textDecoration: 'none',
  maxWidth: '100%',
  color: theme.palette.common.white,

  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: 'transparent'
  },

  '& .MuiTypography-root': {
    flexGrow: 1
  },

  '& span.expand': {
    flexBasis: 'auto'
  },

  '&.is-disabled': {
    pointerEvents: 'none',

    '& .MuiTypography-root, &:hover .MuiTypography-root': {
      color: theme.palette.action.hover
    }
  },

  [theme.breakpoints.up('md')]: {
    '& .MuiTypography-root': {
      transition: theme.transitions.create(['opacity'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.short
      }),
      opacity: 0,

      '.site-navigation:focus-within &, .site-navigation:hover &': {
        opacity: 0.7
      }
    },

    '.menu-item:hover &, .menu-item.opened &, .menu-item.active &': {
      '.site-navigation:focus-within &, .site-navigation:hover &': {
        // outline: '1px solid red',
        opacity: 1
      }
    }
  }
});

export const ExternalLink = superstyled({
  name: 'BusinessEntityNav',
  slot: 'MenuItemExternalLink',
  tag: ZuiLink,
  styles: ({ theme }) => menuItemMixin(theme)
});

export const Link = superstyled({
  name: 'BusinessEntityNav',
  slot: 'MenuItemInternalLink',
  tag: ZuiLink,
  propsAdded: {
    component: NavLink
  },
  styles: ({ theme }) => menuItemMixin(theme)
});

export const Text = superstyled({
  name: 'BusinessEntityNav',
  slot: 'MenuItemText',
  tag: ZuiText,
  styles: ({ theme }) => menuItemMixin(theme)
});

export const Button = superstyled({
  name: 'BusinessEntityNav',
  slot: 'MenuItemButton',
  tag: ListItemButton,
  styles: ({ theme }) => menuItemMixin(theme)
});

export const SubMenu = superstyled({
  name: 'BusinessEntityNav',
  slot: 'ExpandableListItemSubmenu',
  tag: List,
  styles: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    margin: '0',
    padding: '0',
    paddingInlineStart: '3.5rem'
  }
});
